import * as UrlService from '../../shared/services/url.service';
import { Injectable } from '@angular/core';
import { FilterFieldDef } from '../models/filter';
import { SortItem } from '../models/sortItem';
import { convertStringToOdataSortDirection, OdataSort } from '../../shared/services/url.service';

@Injectable()
export class OdataHelperService {

  constructor(
  ) { }

  private replaceSpecialCharacters(value) {
    // replace the single quotes
    value = value.replace(/'/g, "''");

    value = value.replace(/%/g, "%25");
    value = value.replace(/\+/g, "%2B");
    value = value.replace(/\//g, "%2F");
    value = value.replace(/\?/g, "%3F");

    value = value.replace(/#/g, "%23");
    value = value.replace(/&/g, "%26");
    return value;
  }

  public addFilters(filterDef: any, filter: any, filterGroup: UrlService.IOdataFilter[]) {
    if (filter) {
      for (var key in filter) {
        let val = filter[key];
        let def = <FilterFieldDef>filterDef[key];
        if (def && val !== "undefined" && val !== null && val !== '' && val !== undefined) {
          switch (def.type) {
            case 'number':
              if (!isNaN(parseFloat(val.toString()))) {
                var fieldName = def.compareType ? key.replace('_1', '').replace('_2', '') : key;
                filterGroup.push(new UrlService.OdataFilterCompare(
                  new UrlService.OdataFieldName(fieldName),
                  new UrlService.OdataFieldNumber(val),
                  convertCompareType(def.compareType)
                ));
              }
              break;
            case 'string':
              val = this.replaceSpecialCharacters(val);

              if (def.compareType == '=') {
                filterGroup.push(new UrlService.OdataFilterCompare(
                  new UrlService.OdataFieldToLower(new UrlService.OdataFieldName(key)),
                  new UrlService.OdataFieldToLower(new UrlService.OdataFieldString(val)),
                  UrlService.OdataFilterCompareType.Equal
                ));
              }
              else if (def.compareType == '==') {
                filterGroup.push(new UrlService.OdataFilterCompare(
                  new UrlService.OdataFieldName(key),
                  new UrlService.OdataFieldString(val),
                  UrlService.OdataFilterCompareType.Equal
                ));
              }
              else {
                filterGroup.push(new UrlService.OdataFilterSubstringOf(
                  new UrlService.OdataFieldToLower(new UrlService.OdataFieldName(key)),
                  new UrlService.OdataFieldToLower(new UrlService.OdataFieldString(val))
                ));
              }

              break;
            case 'date':
              var strDate = (val instanceof Date
                ? val.toISOString()
                : val).split('T')[0];
              filterGroup.push(new UrlService.OdataFilterCompare(
                new UrlService.OdataFieldOperatorDate(new UrlService.OdataFieldName(key.replace('_1', '').replace('_2', ''))),
                new UrlService.OdataFieldDateOnly(new Date(strDate)),
                convertCompareType(def.compareType)
              ));
              break;
            case 'bool':
              if (typeof val == "boolean") {
                filterGroup.push(new UrlService.OdataFilterCompare(
                  new UrlService.OdataFieldName(key),
                  new UrlService.OdataFieldBoolean(val),
                  UrlService.OdataFilterCompareType.Equal
                ));
              }
              break;
          }
        }
      }
    }
  }

  public addSorts(sortItems: SortItem[], query: UrlService.OdataQuery) {
    if (sortItems) {
      for (var i = 0; i < sortItems.length; i++) {
        query.addSort(
          new OdataSort(new UrlService.OdataFieldName(sortItems[i].column), convertStringToOdataSortDirection(sortItems[i].sortDirection)));
      }

    }
  }
}

function convertCompareType(compareType: any): UrlService.OdataFilterCompareType {
  switch (compareType) {
    case '>=':
      return UrlService.OdataFilterCompareType.GreaterThanOrEqualTo;
    case '<=':
      return UrlService.OdataFilterCompareType.LessThanOrEqualTo;
    case '>':
      return UrlService.OdataFilterCompareType.GreaterThan;
    case '<':
      return UrlService.OdataFilterCompareType.LessThan;
    default:
      return UrlService.OdataFilterCompareType.Equal;
  }
}
